import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const FINANCE_PERMISSIONS = {
  READ: PERMISSIONS.FINANCE_READ,
  WRITE: PERMISSIONS.REFUND_WRITE,
};
export const INVOICE_QUERY_KEYS = queryKeys.invoices;
export const PAYMENT_QUERY_KEYS = queryKeys.payments;
export const INSTALLMENT_QUERY_KEYS = queryKeys.installments;
export const WALLET_QUERY_KEYS = queryKeys.wallets;
export const WITHDRAWAL_QUERY_KEYS = queryKeys.withdrawalRequests;

export const INVOICE_STATUSES = ['DRAFT', 'ISSUED', 'OVERDUE', 'PAID', 'CANCELLED'];
export const PAYMENT_STATUSES = ['PENDING', 'COMPLETED', 'FAILED', 'CANCELLED'];
export const PAYMENT_METHODS = ['BANK_TRANSFER', 'MADA', 'VISA', 'MASTERCARD', 'WALLET', 'DEFERRED'];
export const INSTALLMENT_STATUSES = ['UPCOMING', 'DUE_SOON', 'OVERDUE', 'PAID'];
export const WALLET_ACCOUNT_TYPES = ['BUYER', 'SUPPLIER'];
export const WALLET_STATUSES = ['ACTIVE', 'FROZEN'];
export const WITHDRAWAL_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'COMPLETED', 'CANCELLED'];
